(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ec-faq"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var faqCardTitles = document.querySelectorAll('.faq-card__title');
    faqCardTitles.forEach(function(title) {
      title.addEventListener('click', function() {
        var body = this.nextElementSibling;
        var arrowBar = this.querySelector('.faq-card__arrow-bar');
        if (body.style.maxHeight && body.style.maxHeight !== "0px") {
          body.style.maxHeight = "0px";
          body.classList.remove('open');
          arrowBar.style.transform = 'rotate(-180deg)';
        } else {
          body.style.maxHeight = body.scrollHeight + "px";
          body.classList.add('open');
          arrowBar.style.transform = 'rotate(0deg)';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-featured-product-image"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var parallax = document.querySelector('.parallax-section');

    window.addEventListener('scroll', function () {
      if (parallax) {
        var offset = window.pageYOffset;
        parallax.style.backgroundPositionY = offset * 0 + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-testimonial-white"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var testimonials = Array.from(document.querySelectorAll('.testimonial-block'));
    var currentTestimonialIndex = 0;

    testimonials[currentTestimonialIndex].classList.add('is-visible');

    function cycleTestimonials() {
      testimonials[currentTestimonialIndex].classList.remove('is-visible');
      currentTestimonialIndex = (currentTestimonialIndex + 1) % testimonials.length;
      testimonials[currentTestimonialIndex].classList.add('is-visible');
    }

    setInterval(cycleTestimonials, 4000); // Change testimonial every 4 seconds
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-faq"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var faqCardTitles = document.querySelectorAll('.faq-card__title');
    faqCardTitles.forEach(function(title) {
      title.addEventListener('click', function() {
        var body = this.nextElementSibling;
        var arrowBar = this.querySelector('.faq-card__arrow-bar');
        if (body.style.maxHeight) {
          body.style.maxHeight = null;
          body.classList.remove('open');
          arrowBar.style.transform = 'rotate(-180deg)';
        } else {
          body.style.maxHeight = body.scrollHeight + "px";
          body.classList.add('open');
          arrowBar.style.transform = 'rotate(0deg)';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-hero"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

// Function to create animated text lines
    function createAnimatedLines(textElement, className) {
      var lines = textElement.innerText.split('\n');
      textElement.innerHTML = ''; // Clear the original text
      lines.forEach(function(line, index) {
        var lineDiv = document.createElement('div');
        lineDiv.classList.add('hero-section__text-line');
        var lineElement = document.createElement(
          className === 'header'
            ? 'h1'
            : 'p'
        );
        lineElement.classList.add(
          className === 'header'
            ? 'hero-section__header-text'
            : 'hero-section__subheader-text'
        );
        lineElement.innerText = line;
        lineElement.style.animationDelay = 0.3 + index * 0.1 + 's'; // Staggered delay
        lineDiv.appendChild(lineElement);
        textElement.appendChild(lineDiv);
      });
    }

    var headerText = document.getElementById('hero-header-text');
    var subheaderText = document.getElementById('hero-subheader-text');
    createAnimatedLines(headerText, 'header');
    createAnimatedLines(subheaderText, 'subheader');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-pin-cta"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var images = document.querySelectorAll('.social-cta__image');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting === true) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold: [.35]});

    images.forEach(image => {
      observer.observe(image);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-testimonial-section"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var testimonials = document.querySelectorAll('.lg-testimonial-section__testimonial-content');

    var currentTestimonialIndex = 0;

    // Hide all testimonials at the start
    testimonials.forEach(function(testimonial) {
      testimonial.style.display = 'none';
    });

    // Initialize first testimonial to be visible
    if (testimonials.length > 0) {
      testimonials[currentTestimonialIndex].style.display = 'flex';
      testimonials[currentTestimonialIndex].style.opacity = 1;
    }

    function cycleTestimonials() {
      // Fade out the current testimonial
      testimonials[currentTestimonialIndex].style.opacity = 0;

      // Wait for the fade-out transition, then switch to the next testimonial
      setTimeout(function() {
        testimonials[currentTestimonialIndex].style.display = 'none';
        currentTestimonialIndex = (currentTestimonialIndex + 1) % testimonials.length;
        testimonials[currentTestimonialIndex].style.display = 'flex';

        // Short delay before starting the fade-in to ensure it's visible
        setTimeout(function() {
          testimonials[currentTestimonialIndex].style.opacity = 1;
        }, 10);
      }, 600); // Delay should match the CSS opacity transition time
    }

    // Start cycling testimonials every 6 seconds
    setInterval(cycleTestimonials, 6000);
  });

  } catch(e) { console.error(e); }
})();
})();
